class UserAgentUtil {
	public userAgent: string;

	constructor() {
		this.userAgent = window.navigator.userAgent;
	}

	public get isAndroidChrome(): boolean {
		return !!this.userAgent.match(/Android.*Chrome/);
	}

	public get isChrome(): boolean {
		return this.userAgent.includes('Chrome') &&
			!this.isEdge;
	}

	public get isChromium(): boolean {
		return this.isChrome ||
			this.isEdge;
	}

	public get isDesktopChrome(): boolean {
		return this.isChrome &&
			!this.isAndroidChrome;
	}

	public get isDesktopEdge(): boolean {
		return this.isEdge &&
			!this.userAgent.match(/iPhone|iPad|Android/);
	}

	public get isEdge(): boolean { // Chromium Edge
		return this.userAgent.includes('Edg/');
	}

	public get isElectron(): boolean {
		return this.userAgent.includes('Electron');
	}

	public get isFirefox(): boolean {
		return this.userAgent.includes('Firefox');
	}

	public get isFirefoxMac(): boolean {
		return this.isFirefox && this.userAgent.includes('Mac');
	}

	public get isIe(): boolean {
		return this.userAgent.includes('Trident');
	}

	public get isIeOrLegacyEdge(): boolean {
		return this.isIe || this.isLegacyEdge;
	}

	public get isLegacyEdge(): boolean {
		return this.userAgent.includes('Edge');
	}

	public get isMobile(): boolean {
		return typeof window.orientation === 'number'; // Very simple mobile detection, not 100% reliable (also deprecated)
	}

	public get isSafari(): boolean {
		return !this.isChromium &&
			this.userAgent.includes('Safari');
	}

	public get isSafariIos(): boolean {
		return this.isMobile &&
			/(iPad|iPhone)/.test(this.userAgent);
	}

	public get isSafariMac(): boolean {
		return this.isSafari && !this.isMobile;
	}

	public get isWindows7(): boolean {
		return this.userAgent.includes('Windows NT 6.1');
	}

	public get isApple(): boolean {
		return (/(Mac|iPhone|iPod|iPad)/i).test(navigator.platform);
	}
}

export const userAgentUtil = new UserAgentUtil();
